import { SessionsFilters } from '@/components/layout/Navigation/sessions/header/toolbar/filters';
import { RefreshButton } from '@/components/layout/Navigation/sessions/header/toolbar/refresh';
import { SessionsSort } from '@/components/layout/Navigation/sessions/header/toolbar/sort';
import { SearchButton } from './search';

export const SessionsToolbar = () => {
  return (
    <div className="ml-auto hidden items-center sm:flex">
      <SessionsFilters />
      <SessionsSort />
      <SearchButton />
      <RefreshButton />
    </div>
  );
};
